import { gql } from '@apollo/client';
import { pvWizardSection } from '../fragments/pv-wizard-section.gql';
import image from '../fragments/cloudinary-image.gql';

export default gql`
  query PvWizard {
    pvWizard {
      result {
        headline
        disclaimerText
        sections {
          systemCapacity {
            ...PvWizardSection
          }

          solarYield {
            ...PvWizardSection
          }

          sunKilometers {
            ...PvWizardSection
          }

          solarStorage {
            ...PvWizardSection
          }

          offerSection {
            __typename
            headline
            benefits {
              ... on Benefits {
                __typename
                headline
                listItems
                image {
                  ...CloudinaryImage
                }
              }
            }
            partners {
              ... on Partners {
                headline
                subheadline
                body
                boxes {
                  ... on PartnerBox {
                    partner
                    listItems
                    logo {
                      ...CloudinaryImage
                    }
                  }
                }
              }
            }
            formHeadlines {
              ... on FormHeadlines {
                personalDataHeadline
                deliveryAddressHeadline
                houseDataHeadline
              }
            }
            formModals {
              ... on FormModals {
                locationModal
                deliveryAdressModal
                houseDataModal
                roofAgeModal
                roofMaterialModal
              }
            }
            selectedPartnersContent {
              ... on SelectedPartnersContent {
                headline
                text
              }
            }
            faqs {
              ... on FAQs {
                headline
                accordions {
                  ... on Accordion {
                    headline
                    body
                    initiallyOpen
                  }
                }
              }
            }
          }
        }
      }
      error {
        code
        message
      }
    }
  }

  ${pvWizardSection}
  ${image}
`;
